export default {
	init() {
	},
	finalize() {
		// var filter = $('[data-filter-category-id]');

		// if (filter.length === 0) {
		// 	return;
		// }

		// filter.on('click', filter_by_category);

		$('.category-filter a').on('click', smoothscroll);	
	},
};

// function filter_by_category(e) {
// 	var containers = $('[data-container-category-id]');

// 	if (containers.length > 0) {
// 		containers.each(function (index, value) {
// 			value = $(value);

// 			value.removeClass('hidden');

// 			if (value.data('container-category-id') !== $(e.target).data('filter-category-id')) {
// 				value.addClass('hidden');
// 			}
// 		});
// 	}
// }

function smoothscroll(e) {
	var target = $(this.hash);
	target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	
	if (target.length) {
		e.preventDefault();

		document.querySelector(target.selector).scrollIntoView({ 
			behavior: 'smooth',
			block: 'start',
		});
	}
}


// WEBPACK FOOTER //
// ./scripts/routes/template-file_cabinet.js